/* eslint-disable indent */
/*
 * @providesModule HomeScreenConstants
 */

import ClientPropertyConstants from 'ClientPropertyConstants';
import Preferences from 'Preferences';
import Sizes from 'Sizes';
import {PixelRatio} from 'react-native';

const tabletBalanceBarV1Height = 48;
const phoneUserInfoV1Height = 86;

class HomeScreenConstants {
  TAB_BAR_V2_HEIGHT: number;
  TAB_BAR_V1_HEIGHT_TABLET: number;
  TAB_BAR_V1_HEIGHT_PHONE: number;
  BALANCE_BAR_V2_HEIGHT: number;
  BALANCE_BAR_V1_HEIGHT: number;
  MENU_HEIGHT: number;
  TABLET_LANDSCAPE_SIDE_MARGIN: number;
  CHATBAR_HEIGHT: number;
  LIVE_BRACKET_TOAST_HEIGHT: number;
  LANDSCAPE_TAB_BAR_WIDTH_RATIO: number;
  IPHONEX_HOME_INDICATOR: any;
  SHADOW_OPACITY: number;
  PLAY_SCREEN_V1_MARGIN: number;
  COMBINED_MEDAL_ANIMATION_X_MULTIPLIER: number;
  COMBINED_MEDAL_ANIMATION_Y_MULTIPLIER: number;
  COMBINED_MEDAL_ANIMATION_WIDTH_REDUCTION: number;
  LEAGUE_LOCK_ICON_SIZE: number;
  LEAGUE_LOCK_ICON_CORE_LOOP_SIZE: number;
  FETCH_STORE_INFO_DELAY: number;
  TOUCH_EVENT_LOCKOUT: number;
  DEEP_LINK_COMPLETION_TIMEOUT: number;
  BURST_ANIMATION_SHOWER_TIMEOUT: number;
  MATCH_STREAM_FTUE_TOP: number;
  MATCH_STREAM_FTUE_TOOLTIP_HEIGHT: number;
  MATCH_STREAM_FTUE_V1_INSETS: number;
  MATCH_STREAM_FTUE_V2_INSET_TOP: number;
  MATCH_STREAM_FTUE_V2_INSETS_SIDES: number;

  // Tab Identifiers; these are readonly to get literal typing support
  readonly STREAM = 'HOME';
  readonly PLAY = 'PLAY';
  readonly STORE = 'STORE';
  readonly LEAGUES = 'LEAGUES';
  readonly MENU = 'MENU';

  STREAM_INDEX: number;
  PLAY_INDEX: number;
  STORE_INDEX: number;
  LEAGUES_INDEX: number;
  MENU_INDEX: number;
  NO_SELECTION_INDEX: number;
  CHAT_INDEX: number;
  TO_THE_BACK_HANDLER: {opacity: {value: number; type: string}};
  FROM_THE_FRONT_ANDROID: {
    opacity: {
      from: number;
      to: number;
      min: number;
      max: number;
      type: string;
      extrapolate: boolean;
      round: number;
    };
    transformTranslate: {
      from: {x: number; y: number; z: number};
      to: {x: number; y: number; z: number};
      min: number;
      max: number;
      type: string;
      extrapolate: boolean;
      round: number;
    };
    translateY: {
      from: number;
      to: number;
      min: number;
      max: number;
      type: string;
      extrapolate: boolean;
      round: number;
    };
  };

  ANDROID_STATUS_BAR_HEIGHT: number;
  ANDROID_WELCOME_BACK_DELAY: number;
  ANDROID_STORE_TAB_DELAY: number;
  ANDROID_SIDEMENU_INTERVAL: number;
  ANDROID_SIDEMENU_CLEAR_INTERVAL: number;

  IOS_SIDEMENU_INTERVAL: number;
  IOS_SIDEMENU_CLEAR_INTERVAL: number;
  HOME_INDEX: any;

  constructor() {
    // Assorted constants
    this.TAB_BAR_V2_HEIGHT = Sizes.isTablet() ? 80 : 65;
    this.TAB_BAR_V1_HEIGHT_TABLET = 75;
    this.TAB_BAR_V1_HEIGHT_PHONE = 65;
    this.BALANCE_BAR_V2_HEIGHT = Sizes.isTablet() ? 60 : 45;
    // eslint-disable-next-line no-magic-numbers
    this.BALANCE_BAR_V1_HEIGHT = Sizes.isTablet() ? tabletBalanceBarV1Height : 43;
    // eslint-disable-next-line no-magic-numbers
    this.MENU_HEIGHT = Sizes.isTablet() ? 60 : Sizes.isLandscape() ? 45 : 40;
    this.TABLET_LANDSCAPE_SIDE_MARGIN = 100;
    this.CHATBAR_HEIGHT = 48;
    this.LIVE_BRACKET_TOAST_HEIGHT = 165;
    this.LANDSCAPE_TAB_BAR_WIDTH_RATIO = 0.1;
    this.IPHONEX_HOME_INDICATOR = Sizes.orientation({portrait: 22, landscape: 18});
    this.SHADOW_OPACITY = 0.6;
    this.PLAY_SCREEN_V1_MARGIN = 3;
    this.COMBINED_MEDAL_ANIMATION_X_MULTIPLIER = 1.4;
    this.COMBINED_MEDAL_ANIMATION_Y_MULTIPLIER = 0.5;
    this.COMBINED_MEDAL_ANIMATION_WIDTH_REDUCTION = 70;
    this.LEAGUE_LOCK_ICON_SIZE = 37;
    this.LEAGUE_LOCK_ICON_CORE_LOOP_SIZE = 30;
    // timeouts
    this.FETCH_STORE_INFO_DELAY = 750;
    this.TOUCH_EVENT_LOCKOUT = 3000;
    this.DEEP_LINK_COMPLETION_TIMEOUT = 30000;
    this.BURST_ANIMATION_SHOWER_TIMEOUT = 200;
    // ftue
    this.MATCH_STREAM_FTUE_TOP = 1.5;
    this.MATCH_STREAM_FTUE_TOOLTIP_HEIGHT = 155;
    this.MATCH_STREAM_FTUE_V1_INSETS = 4;
    this.MATCH_STREAM_FTUE_V2_INSET_TOP = 3;
    this.MATCH_STREAM_FTUE_V2_INSETS_SIDES = 14;

    this.STREAM_INDEX = 0;
    this.PLAY_INDEX = 1;
    this.STORE_INDEX = 2;
    this.LEAGUES_INDEX = 3;
    this.MENU_INDEX = 4;
    this.NO_SELECTION_INDEX = 5;
    this.CHAT_INDEX = 6;

    this.TO_THE_BACK_HANDLER = {
      opacity: {
        value: 1,
        type: 'constant',
      },
    };

    this.FROM_THE_FRONT_ANDROID = {
      opacity: {
        from: 0,
        to: 1,
        min: 0.5,
        max: 1,
        type: 'linear',
        extrapolate: false,
        round: 100,
      },
      transformTranslate: {
        from: {x: 0, y: 100, z: 0},
        to: {x: 0, y: 0, z: 0},
        min: 0,
        max: 1,
        type: 'linear',
        extrapolate: true,
        round: PixelRatio.get(),
      },
      translateY: {
        from: 100,
        to: 0,
        min: 0,
        max: 1,
        type: 'linear',
        extrapolate: true,
        round: PixelRatio.get(),
      },
    };

    /* Android */
    this.ANDROID_STATUS_BAR_HEIGHT = 20;
    this.ANDROID_WELCOME_BACK_DELAY = 6000;
    this.ANDROID_STORE_TAB_DELAY = 800;
    this.ANDROID_SIDEMENU_INTERVAL = 5000;
    this.ANDROID_SIDEMENU_CLEAR_INTERVAL = 15000;

    /* iOS */
    this.IOS_SIDEMENU_INTERVAL = 250;
    this.IOS_SIDEMENU_CLEAR_INTERVAL = 5000;
  }

  getHomescreenInitialTab(): number {
    const initialTab =
      Preferences.getClientProperty(ClientPropertyConstants.HOMESCREEN_OPENING_SCREEN) || 'HOME';
    switch (initialTab) {
      case 'HOME':
        return this.STREAM_INDEX;
      case 'PLAY':
        return this.PLAY_INDEX;
      case 'STORE':
        return this.STORE_INDEX;
      case 'LEAGUES':
        return this.LEAGUES_INDEX;
      case 'CHAT':
        return this.CHAT_INDEX;
      default:
        console.debug('opening.screen invalid tab');
        return this.NO_SELECTION_INDEX;
    }
  }

  /**
   * Dynamic Methods
   * To be used when you're not sure if Header & Footer are:
   * V1 (Header has Profile + Hamburger Menu + Currency Bars, Footer has 4 Tabs) or
   * V2 (Header has Currency Bars only Footer has 5 tabs)
   * */
  getBalanceBarHeight(): number {
    const playScreenV2 =
      ClientPropertyConstants.isCoreLoopTungstenEnabled() ||
      ClientPropertyConstants.isCoreLoopTungstenLiteEnabled();
    return playScreenV2 ? this.BALANCE_BAR_V2_HEIGHT : this.BALANCE_BAR_V1_HEIGHT;
  }

  getUserInfoHeight(): number {
    const playScreenV2 =
      ClientPropertyConstants.isCoreLoopTungstenEnabled() ||
      ClientPropertyConstants.isCoreLoopTungstenLiteEnabled();
    if (playScreenV2) {
      return this.getBalanceBarHeight();
    } else {
      return Sizes.isTablet() && Sizes.isPortrait()
        ? this.getBalanceBarHeight() * 2
        : Sizes.isTablet()
          ? tabletBalanceBarV1Height
          : phoneUserInfoV1Height;
    }
  }

  getUserInfoNoBalanceHeight(): number {
    const userInfoHeight = this.getUserInfoHeight();
    const balanceBarHeight = this.getBalanceBarHeight();

    return Sizes.select({
      portraitTablet: userInfoHeight - balanceBarHeight,
      landscapeTablet: userInfoHeight,
      landscapePhone: 0,
      other: userInfoHeight / 2,
    });
  }

  getTabBarHeight(): number {
    return ClientPropertyConstants.isCoreLoopTungstenLiteEnabled()
      ? this.TAB_BAR_V2_HEIGHT
      : Sizes.isTablet()
        ? this.TAB_BAR_V1_HEIGHT_TABLET
        : this.TAB_BAR_V1_HEIGHT_PHONE;
  }

  /**
   * V1 Static Methods
   * When you know that this is a V1 Header or Footer Component (e.g. UserSummary)
   */
  getBalanceBarHeightV1(): number {
    return this.BALANCE_BAR_V1_HEIGHT;
  }

  getUserInfoHeightV1(): number {
    return Sizes.isTablet() && Sizes.isPortrait()
      ? this.getBalanceBarHeightV1() * 2
      : Sizes.isTablet()
        ? tabletBalanceBarV1Height
        : phoneUserInfoV1Height;
  }

  getUserInfoNoBalanceHeightV1(): number {
    const userInfoHeight = this.getUserInfoHeightV1();
    const balanceBarHeight = this.getBalanceBarHeightV1();

    return Sizes.select({
      portraitTablet: userInfoHeight - balanceBarHeight,
      landscapeTablet: userInfoHeight,
      landscapePhone: 0,
      other: userInfoHeight / 2,
    });
  }

  getTabBarHeightV1(): number {
    return Sizes.isTablet() ? this.TAB_BAR_V1_HEIGHT_TABLET : this.TAB_BAR_V1_HEIGHT_PHONE;
  }

  get playScreenV2Enabled(): boolean {
    return (
      ClientPropertyConstants.isCoreLoopTungstenEnabled() ||
      ClientPropertyConstants.isCoreLoopTungstenLiteEnabled()
    );
  }
}

export default new HomeScreenConstants();
